import { useFormInput } from '../../../../shared/FormInput';
import { PERSONAL_FIELDS } from '../../../constants';
import { isUserNameAvailable, STATUS } from '../../services/userNameAvailability';

export const USERNAME_VALIDATION = {
    MIN_LENGTH: 'minLength',
    INVALID_CHARACTERS: 'invalidCharacters',
};

export const MIN_LENGTH = 6;

const usernameValidation = async (username) => {
    if (username.length < MIN_LENGTH) {
        return [false, USERNAME_VALIDATION.MIN_LENGTH];
    }

    if (!username.match(/^[A-Za-z0-9_@.]+$/)) {
        return [false, USERNAME_VALIDATION.INVALID_CHARACTERS];
    }

    const status = await isUserNameAvailable(username);

    return [status === STATUS.FREE, status];
};

export const useUsernameField = (value, onFieldInteracted) =>
    useFormInput({
        name: PERSONAL_FIELDS.USERNAME,
        initialValue: value,
        onFieldInteracted,
        validationFunc: usernameValidation,
    });
